function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M30.1,43.8c0,1.7-1,3-2.6,4.1c8.6,2.5,21.5,0.1,21.5-4.3v-2.9C45.2,43.8,37,44.9,30.1,43.8z"
}), React.createElement("path", {
  d: "M30.1,37c0,0.6-0.2,1.2-0.4,1.7c0.3,0.6,0.4,1.2,0.4,1.9v1.1c6.9,1.2,15.2-0.1,18-3c0.6-0.6,0.9-1.2,0.9-1.9   c0-5.4,0-0.7,0-2.9c-0.6,0.5-1.4,1-2.3,1.4C42.4,37.3,35.6,37.8,30.1,37z"
}), React.createElement("path", {
  d: "M30.1,30.1c0,0.6-0.2,1.2-0.4,1.7c0.3,0.5,0.4,1.1,0.4,1.7c0,0,0,0.1,0,0.1v1.1c1.6,0.3,3.4,0.4,5.3,0.4   c3.7,0,10.1-0.8,12.7-3.4c0.6-0.6,0.9-1.2,0.9-1.9c0-5.4,0-0.6,0-3c-0.6,0.5-1.4,1-2.3,1.4C42.4,30.5,35.6,31,30.1,30.1z"
}), React.createElement("path", {
  d: "M35.5,14.7c-1.9,0-3.7,0.1-5.3,0.4v1.1c0,0.7-0.1,1.3-0.4,1.9c0.5,1.1,0.4,1.9,0.4,3.8c0,1.2,0.1,1.9-0.4,3   c0.5,1,0.4,1.9,0.4,3c6.6,1.1,15.2-0.1,18-3c0.6-0.6,0.9-1.2,0.9-1.9c0-1.6,0-2.4,0-3.1C49,17.1,43,14.7,35.5,14.7z"
}), React.createElement("path", {
  d: "M28,40.7c-3.3,2.6-9.2,3.5-13.5,3.5C9.2,44.2,3.9,43,1,40.7v2.9c0,2.9,6.1,5.3,13.5,5.3c7.2,0,13.5-2.3,13.5-5.3   C28,42.6,28,41.8,28,40.7z"
}), React.createElement("path", {
  d: "M14.5,42.1c4.3,0,10.3-0.9,12.7-3.4c0.6-0.6,0.9-1.2,0.9-1.9c0-1.2,0,1.4,0-2.8v-0.1c-5.4,4.5-21.1,4.8-27,0v2.8v0.2   c0,0.7,0.3,1.3,0.9,1.9C3.8,40.7,8.7,42.1,14.5,42.1z"
}), React.createElement("path", {
  d: "M1.9,31.8c4.4,4.6,21.1,4.4,25.3,0c0.6-0.6,0.9-1.2,0.9-1.9c0-1.3,0-1.6,0-2.8V27c-5.6,4.7-21.2,4.7-27,0   c0,1.7,0,1.2,0,2.9C1,30.6,1.3,31.3,1.9,31.8L1.9,31.8z"
}), React.createElement("path", {
  d: "M1.9,25c4.3,4.4,20.8,4.6,25.3,0c0.6-0.6,0.9-1.2,0.9-1.9c0-1.4,0-1.7,0-2.8v-0.1C22.6,24.7,7,25,1,20.2   C1,23.3,0.8,23.9,1.9,25L1.9,25z"
}), React.createElement("path", {
  d: "M1.9,18.2c0.9,0.9,2.4,1.7,4.4,2.3h0c7.1,2.2,17.6,1,20.9-2.3c0.6-0.6,0.9-1.2,0.9-1.9c0-1.2,0,0.2,0-2.9   C22.3,18,6.8,18,1,13.4v2.8v0.2C1,17,1.3,17.6,1.9,18.2L1.9,18.2z"
}), React.createElement("path", {
  d: "M27.2,11.3c1.1-1.1,0.9-1.6,0.9-5c0-2.9-6-5.3-13.5-5.3C7.1,1.1,1,3.4,1,6.3C1,9,1,3.2,1,9.5c0,0.7,0.3,1.3,0.9,1.9   C6.3,15.9,22.9,15.8,27.2,11.3z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#379B75",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/money_icon.1e55dd04.svg";
export { SvgComponent as ReactComponent };